/* eslint semi:0 */
import BaseClass from '../../application/BaseClass'
import SignupModalVm from '../vms/SignupModalVm'
import SignupModalView from '../views/SignupModalView'
import SignupModalStore from '../stores/SignupModalStore'
import { make as makeComponent } from '../../utils/component'

class SignupModalController extends BaseClass {
  constructor(options = {}) {
    super(options)
    let store = options.store || SignupModalStore.create(options)
    let vm = SignupModalVm.create(Object.assign({ store }, options))
    this.merge({
      vm,
      store,
    })
    store.vm = vm
  }
}

export default makeComponent(SignupModalController, SignupModalView)



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/components/signupModalComponent.js